import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class DocumentService {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getDocument(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/official_documents_by_status/?status=${payload.status}`,
      {
        params: payload.params,
      }
    );
  }
  getALLDocument(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/official_documents`,
      {
        params: payload.params,
      }
    );
  }
  getAllSupportingDocument(payload) {
    return this._http.get(`${this.baseUrl}/supporting-documents`, {
      params: payload.params,
    });
  }
  getPendingDocument(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/official_documents/${payload.docId}/pending`
    );
  }

  getHistoryDocument(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/official_documents/${payload.docId}/history`
    );
  }
  getDocuments(payload) {
    return this._http.get(
      `${this.baseUrl}/organization/${payload.organizationId}/official_documents/`,
      {
        params: payload.params,
      }
    );
  }
  addDocument(payload) {
    return this._http.post(
      `${this.baseUrl}/organization/${payload.organizationId}/official_documents/`,
      payload.body
    );
  }
  uploadDocument(payload) {
    return this._http.post(`${this.baseUrl}/document/upload/`, payload.body);
  }
  updateDocument(payload) {
    return this._http.put(
      `${this.baseUrl}/organization/${payload.organizationId}/official_documents/${payload.docId}/status/${payload.status}/`,

      payload.body
    );
  }
  deleteRequestDocument(payload) {
    return this._http.patch(
      `${this.baseUrl}/change-request/discard/${payload.id}`,
      payload.body
    );
  }
  updateSupportingDocument(payload) {
    return this._http.patch(
      `${this.baseUrl}/supporting-documents/status?supportingDocumentId=${payload.supportingDocumentId}&status=${payload.status}`,
      payload.body
    );
  }
  effectShareholder(payload) {
    return this._http.put(
      `${this.baseUrl}/change-request/effect/?changeRequestId=${payload.changeRequestId}`,
      payload.body
    );
  }
  removeDocument(payload) {
    return this._http.delete(
      `${this.baseUrl}/organization/${payload.organizationId}/official_documents/${payload.id}/`
    );
  }

  uploadSupportingDocument(payload) {
    return this._http.post(
      `${this.baseUrl}/change-request/add-document/${payload.changeRequestId}/`,
      payload.body,
      {
        reportProgress: true,
        observe: 'events',
      }
    );
  }
}
